import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled, TitleHeading } from '../../../ui/Elements'
import { ArrowBtnBrown, BrandArrowLeft, BrandArrowRight, ComMap, MBS, ServicesBg, ServicesImg, ServicesImgAr, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../../ui/AllImages'
import Slider from 'react-slick'
import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import { BrandDataConfig, ServicesList, StatsList, VisionMissionList, WhyChooseList } from '../../projectData/Data'
import Clients from '../clients/Clients'
import { Animate } from 'react-simple-animate'

const WhyChooseUs = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
                  const [isVisible, setIsVisible] = useState(false);
            useEffect(() => {
                    const observer = new IntersectionObserver(
                      ([entry]) => {
                        // When visible, set to true
                        if (entry.isIntersecting) {
                          setIsVisible(true);
                          observer.disconnect(); // run animation once
                        }
                      },
                      {
                        threshold: 0.2, // 20% of section visible triggers the animation
                      }
                    );
                
                    if (sectionRef.current) {
                      observer.observe(sectionRef.current);
                    }
                
                    return () => observer.disconnect();
                  }, []);
                    const start = { opacity: 0, transform: 'translateY(-40px)' };
                    const end = { opacity: 1, transform: 'translateY(0)' };
                    const start2 = { opacity: 0, transform: 'translateY(100px)' };
                    const end2 = { opacity: 1, transform: 'translateY(0)' };

    return (
        <>
        <Box id='whyChooseUs'>
            <WhyChooseWapper className='container-fluid secWhyChoose common-space' ref={sectionRef}>
                <Container>
                    <Row className='why-choose-row'>
                        <Animate
                                                    play={isVisible}
                                                    duration={1}
                                                    delay={.5}
                                                    start={start}
                                                    end={end}
                                                >
                        <InnerHeading className='sub-heading sub-heading-whyChoose' color="var(--secondaryColor)">
                            {t('whyHisas')}
                        </InnerHeading>
                        </Animate>
                        <Animate
                                                    play={isVisible}
                                                    duration={1}
                                                    delay={1}
                                                    start={start}
                                                    end={end}
                                                >
                        <MainHeading className='main-heading main-heading-why-choose mb-5'>
                            {t('whatMakeUnique')}
                        </MainHeading>
                        </Animate>
                         <Col lg={12} className='' >
                         <Animate
                                                    play={isVisible}
                                                    duration={1}
                                                    delay={1.5}
                                                    start={start}
                                                    end={end}
                                                >
                            <Row className='whyRow'>
                                {WhyChooseList.map((list, key) => (
                                    
                                    <Col className='why-choose-col' key={key}>
                                        
                                        <Box className="why-choose-col-inner">
                                            <Box className='whyChooseIconImg'>
                                                {list.img}
                                            </Box>
                                            <Box className='whyChooseContentInner'>
                                                <SpanStyled className='why-choose-txt' color='var(--secondaryColor)' size="18px">
                                                    {t(list.txt)}
                                                </SpanStyled>
                                            </Box>
                                        </Box>
                                        
                                    </Col>
                                ))}
                            </Row>
                            </Animate>
                         </Col>
                        
                    </Row>
                    
                </Container>
            </WhyChooseWapper>
            
        </Box>
        
        </>
    )
}
const WhyChooseWapper = styled.section`
    padding-top: 0px;
    padding-bottom: 100px;
    padding-top: 100px;
    .sub-heading-whyChoose{
        text-align: center;
    }
    .main-heading-why-choose{
        text-align: center;
        padding-bottom: 15px;
    }
    
    .why-choose-col-inner{
        background-color: var(--bg);
        border-radius: 50px 0 50px 0;
        padding: 40px 20px 40px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }
    .whyChooseIconImg{
        display: flex;
        width: 100px;
        height: 100px;
        justify-content: center;
        border-radius: 50%;
        align-items: center;
        border: 2px solid var(--secondaryColor);
    }
    .statsContentInner{
        /* padding-top: 10px; */
    }
    .main-heading-stats{
        text-align: center;
    }
    .why-choose-txt{
        width: 100%;
        text-align: center;
        margin-top: 25px;
    }


    
    body.rtl &{
        .sub-heading-whyChoose{
            font-size: 48px;
        }
        .why-choose-txt{
            
        }
    }
    @media (max-width: 1199px) {
        
        
        
    }
    @media (max-width: 991px) {
        padding-top: 60px;
        padding-bottom: 60px;
        .main-heading-why-choose{
            margin-bottom: 30px !important;
        }
        .why-choose-col{
            flex: 0 0 auto;
            width: 50%;
            margin-bottom: 20px;
            
        }
        .whyRow{
        justify-content: center;
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        .why-choose-col{
            flex: 0 0 auto;
            width: 100%;
            
        }
    }
`
export default WhyChooseUs
